import { ItemType } from '@vista-digital/ocapi-types/v1';
import { temporaryOrderDomainStore } from '../../../temporary-store/store';
import { mapInProgressNormalItemToOrderNormalItemLine } from './map-in-progress-normal-item-to-order-normal-item-line';
import { mapInProgressParentSalesItemToOrderNormalItemLines } from './map-in-progress-parent-sales-item-to-order-normal-item-lines';
export const mapInProgressItemToOrderItemLines = (inProgressItem) => {
    // Update structure of normal in-progress item to take a quantity prop. References to 'foundInProgressItem' can be removed after that.
    const foundInProgressItem = temporaryOrderDomainStore.data.inProgressItems.find(i => i.id === inProgressItem.id);
    if (!foundInProgressItem) {
        throw new Error(`Could not find in-progress item ${inProgressItem.id}`);
    }
    if (!foundInProgressItem.isValid) {
        throw new Error(`The in-progress item ${foundInProgressItem.id} is not yet ready to be added to an order`);
    }
    const orderItems = mapInProgressItem(foundInProgressItem);
    return orderItems.map(orderItem => {
        return Object.assign(Object.assign({}, orderItem), { rewardId: orderItem.rewardId || foundInProgressItem.rewardId, discountId: orderItem.discountId || foundInProgressItem.discountId });
    });
};
const mapInProgressItem = (inProgressItem) => {
    switch (inProgressItem.type) {
        case ItemType.Normal:
            return [mapInProgressNormalItemToOrderNormalItemLine(inProgressItem)];
        case ItemType.ParentSales:
            return mapInProgressParentSalesItemToOrderNormalItemLines(inProgressItem);
        default:
            throw 'Unsupported item type';
    }
};
